export default function XSD_Numeric() {
  return (
    <div>
      <h1>XSD_Numeric</h1>
      <p>This is the XSD_Numeric component.</p>
    </div>
  );
}